export class SecurityScanResult {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "evidenceType",
            "baseName": "evidenceType",
            "type": "SecurityScanResultEvidenceTypeEnum",
            "format": ""
        },
        {
            "name": "path",
            "baseName": "path",
            "type": "string",
            "format": ""
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "SecurityScanResultTypeEnum",
            "format": ""
        },
        {
            "name": "justification",
            "baseName": "justification",
            "type": "string",
            "format": ""
        },
        {
            "name": "score",
            "baseName": "score",
            "type": "number",
            "format": "float"
        },
        {
            "name": "anomalyGraph",
            "baseName": "anomalyGraph",
            "type": "AnomalyGraphData",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SecurityScanResult.attributeTypeMap;
    }
    constructor() {
    }
}
export var SecurityScanResultEvidenceTypeEnum;
(function (SecurityScanResultEvidenceTypeEnum) {
    SecurityScanResultEvidenceTypeEnum["SuspiciousExtensionDetected"] = "suspicious_extension_detected";
    SecurityScanResultEvidenceTypeEnum["SuspiciousActivityDetected"] = "suspicious_activity_detected";
    SecurityScanResultEvidenceTypeEnum["ModifiedFilesBecameEncrypted"] = "modified_files_became_encrypted";
    SecurityScanResultEvidenceTypeEnum["MalwareDetected"] = "malware_detected";
    SecurityScanResultEvidenceTypeEnum["TableDeletion"] = "table_deletion";
    SecurityScanResultEvidenceTypeEnum["SignificantRowDecrease"] = "significant_row_decrease";
    SecurityScanResultEvidenceTypeEnum["HighChangePercentage"] = "high_change_percentage";
    SecurityScanResultEvidenceTypeEnum["KmsUnavailableResources"] = "kms_unavailable_resources";
    SecurityScanResultEvidenceTypeEnum["DbRansomNoteTableName"] = "db_ransom_note_table_name";
    SecurityScanResultEvidenceTypeEnum["DbRansomNoteContent"] = "db_ransom_note_content";
    SecurityScanResultEvidenceTypeEnum["MassFileDeleteAnomaly"] = "mass_file_delete_anomaly";
    SecurityScanResultEvidenceTypeEnum["RansomwareNote"] = "ransomware_note";
})(SecurityScanResultEvidenceTypeEnum || (SecurityScanResultEvidenceTypeEnum = {}));
export var SecurityScanResultTypeEnum;
(function (SecurityScanResultTypeEnum) {
    SecurityScanResultTypeEnum["File"] = "FILE";
    SecurityScanResultTypeEnum["Directory"] = "DIRECTORY";
    SecurityScanResultTypeEnum["Database"] = "DATABASE";
    SecurityScanResultTypeEnum["Schema"] = "SCHEMA";
    SecurityScanResultTypeEnum["Table"] = "TABLE";
    SecurityScanResultTypeEnum["Column"] = "COLUMN";
    SecurityScanResultTypeEnum["Row"] = "ROW";
})(SecurityScanResultTypeEnum || (SecurityScanResultTypeEnum = {}));
